<template>
  <div>
    <TextEditor
      ref="comment"
      :editorOption="options"
      @editorChange="updateEditorData"
      :content.sync="editorData.html"
      :enableCharsLimit="enableCharsLimit"
    />
    <div class="upload_attachment">
      <el-upload
        ref="upload"
        action="/api/file/upload"
        multiple
        :limit="limit"
        :on-change="onUpload"
        :on-exceed="onExceed"
        :file-list="fileList"
        :before-upload="examFile"
      >
        <div class="row">
          <!-- <span>{{ $t('supportTickets.attachments') }}</span> -->
          <el-button class="blue_button upload_btn mr-0 mb-0">{{ $t('common.field.upload') }}</el-button>
        </div>
      </el-upload>
    </div>
  </div>
</template>

<script>
import TextEditor from '@/components/TextEditor';
import uploadMixin from '@/mixins/upload';
export default {
  name: 'CommentSection',
  mixins: [uploadMixin],
  components: { TextEditor },
  props: {
    fileList: {
      type: Array,
      default: () => []
    },
    editorData: {
      type: Object,
      default: () => ({})
    },
    enableCharsLimit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: {
        modules: {
          // toolbar: [
          //   ['bold', 'italic', 'underline', 'strike'],
          //   [{ list: 'ordered' }, { list: 'bullet' }],
          //   [{ color: [] }, { background: [] }],
          //   [{ align: 'center' }, { align: 'right' }, { align: 'justify' }]
          // ]
          toolbar: null,
          keyboard: {
            bindings: {
              tab: false,
              handleEnter: {
                key: 13,
                handler: function () {
                  // Do nothing (to prevent enter key)
                }
              },
              paragraphBreak: {
                key: 13,
                shiftKey: true,
                handler: function () {
                  // Do nothing (to prevent shift + enter key)
                }
              }
            }
          }
        }
      },
      allowedFile: ['png', 'jpg', 'jpeg', 'pdf', 'mp4', 'avi', 'wmv', 'mov', 'webm', 'ogg'],
      limit: 5
    };
  },
  methods: {
    onUpload(file) {
      const fileSizeValid = this.fileSizeCheck(file);
      const fileTypeValid = this.isFileSupported(file);

      if (!fileSizeValid) {
        this.$message({
          message: this.$t('fileUploader.maxSize', { maxSize: 5 }),
          type: 'error'
        });
      }

      if (!fileTypeValid) {
        this.$message({
          message: `${this.$t('fileUploader.supportedFormat').split(':')[0]}: ${this.allowedFile.join(', ')}`,
          type: 'error'
        });
      }

      if (fileSizeValid && fileTypeValid) {
        this.$emit('update:fileList', this.$refs.upload.uploadFiles);
      }
    },
    examFile(file) {
      if (!this.fileSizeCheck(file)) {
        return false;
      }
      if (!this.isFileSupported(file)) {
        return false;
      }
      return true;
    },
    fileSizeCheck(file) {
      if (file.size / 1024 / 1024 > 5) {
        return false;
      }
      return true;
    },
    onExceed() {
      this.$message({
        message: this.$t('fileUploader.maxFileNum', { maxFileNum: this.limit }),
        type: 'error'
      });
    },
    updateEditorData(data) {
      this.$emit('update:editorData', data);
    }
  }
};
</script>
